import { render, staticRenderFns } from "./HeaderIndex.vue?vue&type=template&id=5f36c71e&scoped=true"
import script from "./HeaderIndex.vue?vue&type=script&lang=js"
export * from "./HeaderIndex.vue?vue&type=script&lang=js"
import style0 from "./HeaderIndex.vue?vue&type=style&index=0&id=5f36c71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36c71e",
  null
  
)

export default component.exports